import { FSCollections } from '@src/constants/database';

const ORG_WIDE_DIVISION_ID = 'N/A';

type DivisionNameSource = {
  name?: string;
};

/**
 * Resolves a division label for the org-wide audit list title.
 * Org-scoped rows (`N/A` / empty) and the divisions entity itself are omitted.
 */
export const resolveAuditLogDivisionName = (
  divisionId: string | undefined | null,
  entityType: string,
  divisionNameById: Record<string, DivisionNameSource | undefined>,
): string | undefined => {
  const id = typeof divisionId === 'string' ? divisionId.trim() : '';
  if (!id || id.toUpperCase() === ORG_WIDE_DIVISION_ID) {
    return undefined;
  }

  if (entityType === FSCollections.DIVISIONS) {
    return undefined;
  }

  const name = divisionNameById[id]?.name;
  if (typeof name !== 'string') {
    return undefined;
  }

  const trimmed = name.trim();
  return trimmed || undefined;
};
